'use client';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

/**
 * Details summary component, contains a the heading to toggle the content.
 *
 * @example
 * <Details.Summary>Heading</Details.Summary>
 */
const DetailsSummary = forwardRef(function DetailsSummary({ className, ...rest }, ref) {
    /* Set `className` as `class` so react is happy */
    return jsx("u-summary", { ref: ref, class: className, ...rest });
});

export { DetailsSummary };
